import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getCourseBySlug } from 'redux/actions';
import { isFetchingCourse } from 'redux/reducers';
import { isAuthed, getToken } from 'redux/query';

export const useWithCourse = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();

  const authed = useSelector(isAuthed);
  const token = useSelector(getToken);
  const isFetching = useSelector((state) => authed && isFetchingCourse(state));

  useEffect(() => {
    if (authed && token) {
      dispatch(getCourseBySlug(slug));
    }
  }, [token]);

  return {
    isAuthed: authed,
    isFetching,
    token
  };
};
